import ResetPasswordTemplate from "../../../core/components/__templates/ResetPasswordTemplate/ResetPasswordTemplate";

const ResetPassword = () => {
  return <ResetPasswordTemplate/>
};

export default ResetPassword;
